import React from "react";
import PropTypes from "prop-types";
import { InputField } from "../../FormField";

const Policy = ({ data }) => {
  const policyNumber = data["PolicyNumber"] || {};
  const companyName = data["CompanyName"] || {};

  return (
    <fieldset>
      <h3>POLICY INFORMATION</h3>
      <section className="basicinfo display-flex-center">
        <div style={{ flex: "1 0 300px" }}>
          <label htmlFor="PolicyNumber">Policy Number</label>
          <div className="field-container" id="RO_PolicyNumber">
            <InputField name="PolicyNumber" {...policyNumber} />
          </div>
        </div>
        <div style={{ flex: "2 0 600px" }}>
          <label htmlFor="CompanyName">Name of Company</label>
          <div className="field-container" id="RO_CompanyName">
            <InputField name="CompanyName" {...companyName} />
          </div>
        </div>
      </section>
    </fieldset>
  );
};

Policy.propTypes = {
  data: PropTypes.object,
};

export default Policy;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/Aia/AIAHD201906/Policy.jsx